const subscriptionContainer = document.querySelector(".subscription-system-heading-sub-block");
const subscriptionHeading = document.querySelectorAll(".subscription-system-heading");
const subscriptionTable = document.querySelectorAll(".subscription-system-table");
const subscriptionMobileTable = document.querySelectorAll(".subscription-system-table-mobile-monthly-container");

subscriptionContainer.addEventListener("click", function(e) {
  const clicked = e.target.closest(".subscription-system-heading");
  if (!clicked) return null;
  subscriptionHeading.forEach( sh => sh.classList.remove("subscription-system-heading--active") );
  clicked.classList.add("subscription-system-heading--active");
  subscriptionTable.forEach( st => st.classList.remove("subscription-system-table--active") );
  document.querySelector(`.subscription-system-table-${clicked.dataset.heading}`).classList.add("subscription-system-table--active");
  subscriptionMobileTable.forEach( smt => smt.classList.remove("subscription-system-table-mobile--active") );
  document.querySelector(`.subscription-system-table-mobile--${clicked.dataset.heading}`).classList.add("subscription-system-table-mobile--active");
});